import React, {useContext, useEffect} from "react";
import {RecordsManagementContext} from "../StatesMangement/InitialiseContext";
import {ConvertTime} from "../CommonComponents/CommonFunctions";
import OpenSignPad from "../CommonComponents/SignPadForEsigns";

export default () => {//shows the estimate and company information
    let Record = useContext(RecordsManagementContext)
    let EstimateAndCompanyInfoData = Record.CP_PageDetails.EstimateAndCompanyInfo
    let EstimateDetails = Record.CP_PageDetails.EstimateDetails
    let Estimate = EstimateAndCompanyInfoData.Estimate
    let is_scheduled = EstimateDetails.JobDetails
    is_scheduled = is_scheduled.JobDetails == undefined ? is_scheduled : is_scheduled.JobDetails
    let CompanyBranch = EstimateAndCompanyInfoData.CompanyBranch
    const estimateLabels = {guaranteed: "Binding Estimate", hourly: "Non-Binding Estimate", not_to_exceed: "Non-Binding Estimate", tariff_default: "Binding Estimate"};
    let BookedOrNonBookedTag =Record.IsJobBooked || is_scheduled.IsScheduled
        ? <button className="deposit">BOOKED</button> : <button className="deposit not-booked-red">NOT-BOOKED</button>
    let DepositTag = EstimateAndCompanyInfoData.IsPortalPaymentDeposit ?
        <button className="deposit booked-green">PAID DEPOSIT</button> : ''

    return (
        <>
            <div className="row mb-2 top_space" >
                <div className="col-sm-4">
                    <div className="estimate-services">
                        <h4>{Estimate.EstimateFor}</h4>
                        <div className="booked-btn">
                            {BookedOrNonBookedTag}
                            {DepositTag}
                        </div>
                        <span>Estimate : #{Estimate.SerialNumber}</span>
                        { Estimate.EstimateType !=="guaranteed" &&   !Record.IsJobOpen?
                            <>
                                { Estimate.EstimateType !== "tariff_default"  && !EstimateDetails.ShowPriceRange ?
                                    <span>Total Estimated Price Range : {Estimate.PriceRange}</span>
                                    : <></> }
                                {Estimate.ShowTotalHours ?
                                    <></>
                                    : Estimate.TravelPriceCheckList ?
                                        <span>Total Estimated Hours : {Estimate.TotalHours} Hours</span> : <></>
                                }
                            </> :
                            <></> }
                    </div>
                </div>
                <div className="col-sm-4 text-sm-center">
                    <div className="logo-container">
                        <img
                            src={CompanyBranch.Logo}
                            alt="logo"
                            className="responsive-logo"
                        />
                    </div>
                </div>
                <div className="col-sm-4 text-sm-right">
                    <div className="estimate-services">
                        <h4>{CompanyBranch.Name}</h4>
                        <div className="booked-btn">
                            <span>{CompanyBranch.Address}</span>
                            {CompanyBranch.SuiteNumber ?
                                <span>Suite/Unit Number: {CompanyBranch.SuiteNumber}</span> : <></>}
                            {CompanyBranch.StateAuthority ?
                                <span>{CompanyBranch.StateAuthority}</span> : <></>}
                            {CompanyBranch.UsDot ?
                                <span>{CompanyBranch.UsDot}</span> : <></>}
                            <span>{CompanyBranch.Mail}</span>
                        </div>
                        <p>{estimateLabels[Estimate.EstimateType] || ""}</p>
                    </div>
                </div>
            </div>

        </>
    );
};